module.exports = __webpack_public_path__ + "static/media/4.90d7458a.png";